export function formatTZS(value) {
  const amount = Number(value);
  if (!Number.isFinite(amount)) {
    return "TZS 0";
  }
  const formatted = new Intl.NumberFormat("en-TZ", {
    maximumFractionDigits: 0,
  }).format(Math.round(amount));
  return `TZS ${formatted}`;
}

/** Compact TZS for chart axes (e.g. TZS 1.2M). */
export function formatCompactTZS(value) {
  const amount = Number(value);
  if (!Number.isFinite(amount) || amount === 0) {
    return "TZS 0";
  }
  const abs = Math.abs(amount);
  const sign = amount < 0 ? "-" : "";
  if (abs >= 1_000_000_000) {
    return `${sign}TZS ${(abs / 1_000_000_000).toFixed(1)}B`;
  }
  if (abs >= 1_000_000) {
    return `${sign}TZS ${(abs / 1_000_000).toFixed(1)}M`;
  }
  if (abs >= 1_000) {
    return `${sign}TZS ${(abs / 1_000).toFixed(0)}K`;
  }
  return formatTZS(amount);
}

export function formatPercent(value) {
  const pct = Number(value);
  if (Number.isNaN(pct)) {
    return "0%";
  }
  return `${pct.toFixed(1)}%`;
}

export function formatDate(value) {
  if (!value) {
    return "—";
  }
  return new Date(value).toLocaleDateString("en-TZ", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function formatDateTime(value) {
  if (!value) {
    return "—";
  }
  return new Date(value).toLocaleString("en-TZ", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
